// @vendors
import React from 'react'
import { Badge, Box } from '@mui/material';

const WotcBadge = ({bgColor}) => {
    
  return (
    <Badge
        color="secondary"
        badgeContent={0}
        variant="dot"
    >
        <Box
            component="span"
            sx={{
              bgcolor: bgColor,
              width: '25px',
              height: '25px',
              borderRadius: '3px'
            }}
        />
    </Badge>
  )
}

export default WotcBadge